import React from 'react';
import PropTypes from 'prop-types';
import { first, uniqBy } from 'lodash';
import { Translate } from 'core/translate';
import {
  ModalFooter,
  ModalFooterButtons,
  ModalFooterCancelButton,
  ModalFooterMessage,
  ModalFooterPrimaryButton
} from '../../common/modal/Modal';
import ConfigAssistant from '../../common/configAssistant/ConfigAssistant';
import ConfigAssistantDriveToggle from '../../common/configAssistant/ConfigAssistantDriveToggle';
import {
  buildDriveOptions,
  combineWithConfig
} from '../../common/configAssistant/data';
import ConfigAssistantMessage from '../../common/configAssistant/ConfigAssistantMessage';
import TrimsAndEnginesListView from '../../common/configAssistant/TrimsAndEnginesListView';
import ConfigsAndEnginesListView from '../../common/configAssistant/ConfigsAndEnginesListView';

class FeaturesCapabilitiesSelect extends React.Component {
  constructor(props) {
    super(props);

    const { matrix, config } = props;

    const options = combineWithConfig(config)(matrix);

    const driveOptions = buildDriveOptions(options, config.driveTypes);

    this.state = {
      options,
      driveOptions,
      selectedDriveOption: first(driveOptions),
      selectedOption: null
    };
  }

  onDriveOptionChange = option => {
    this.setState({
      selectedDriveOption: option,
      selectedOption: null
    });
  };

  onOptionChange = option => {
    this.setState(prevState => ({
      selectedOption: prevState.selectedOption === option ? null : option
    }));
  };

  render() {
    const { classicModel, onCancel, onSubmit } = this.props;
    const {
      options,
      selectedOption,
      driveOptions,
      selectedDriveOption
    } = this.state;

    const hasSingleEngine = uniqBy(options, 'engine').length === 1;

    const listView = classicModel ? (
      <TrimsAndEnginesListView
        options={options}
        driveOptions={driveOptions}
        flattened={hasSingleEngine}
        selectedDriveOption={selectedDriveOption}
        selectedOption={selectedOption}
        renderHeader={x => x.trimName}
        onChange={this.onOptionChange}
      />
    ) : (
      <ConfigsAndEnginesListView
        options={options}
        driveOptions={driveOptions}
        flattened={hasSingleEngine}
        selectedDriveOption={selectedDriveOption}
        selectedOption={selectedOption}
        onChange={this.onOptionChange}
      />
    );

    return (
      <div className="features__body features__body--flex">
        <div className="modal__content">
          <div className="features__config-assistant-container">
            <ConfigAssistant
              message={
                <ConfigAssistantMessage>
                  <Translate value="configuration.assistant.choose.config" />
                </ConfigAssistantMessage>
              }
              driveToggle={
                driveOptions.length > 1 && (
                  <ConfigAssistantDriveToggle
                    options={driveOptions}
                    selected={selectedDriveOption}
                    onChange={this.onDriveOptionChange}
                  />
                )
              }
              list={listView}
            />
          </div>
        </div>
        <ModalFooter className="features__footer">
          <ModalFooterMessage>
            {!selectedOption && (
              <Translate value="configuration.assistant.continue" />
            )}
          </ModalFooterMessage>
          <ModalFooterButtons>
            <ModalFooterCancelButton
              onClick={onCancel}
              data-dtm="compare capabilities"
            />
            <ModalFooterPrimaryButton
              onClick={() => {
                onSubmit(selectedOption);
              }}
              disabled={!selectedOption}
              data-dtm="compare capabilities">
              <Translate value="component.trim.compare.compare" />
            </ModalFooterPrimaryButton>
          </ModalFooterButtons>
        </ModalFooter>
      </div>
    );
  }
}

FeaturesCapabilitiesSelect.propTypes = {
  matrix: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired,
  classicModel: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default FeaturesCapabilitiesSelect;
